'use strict';

Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });

const tslib_es6 = require('../../../tslib.es6-CZ43up4V.js');
const jsxRuntime = require('react/jsx-runtime');
const components_marketing_SubscriptionForm_SubscriptionForm = require('./SubscriptionForm.cjs.js');
const components_marketing_SubscriptionForm_DisclaimerText = require('./DisclaimerText.cjs.js');

const ctaContainer = "_cta-container_17ytn_1";
const styles = {
	ctaContainer: ctaContainer
};

const SubscriptionFormWithDisclaimer = (_a) => {
  var { disclaimerTextColor = "primary", disclaimerTextType } = _a, restProps = tslib_es6.__rest(_a, ["disclaimerTextColor", "disclaimerTextType"]);
  return jsxRuntime.jsxs("div", { className: styles.ctaContainer, "data-zds": true, children: [jsxRuntime.jsx(components_marketing_SubscriptionForm_SubscriptionForm.SubscriptionForm, Object.assign({}, restProps, { fluidInput: true })), jsxRuntime.jsx(components_marketing_SubscriptionForm_DisclaimerText.DisclaimerText, { color: disclaimerTextColor, textType: disclaimerTextType })] });
};

exports.SubscriptionFormWithDisclaimer = SubscriptionFormWithDisclaimer;
//# sourceMappingURL=SubscriptionFormWithDisclaimer.cjs.js.map
